import React from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useLocation } from 'react-router'
import { deleteSearchParams, setManySearchParamValues } from 'lib/url/searchUrlUtils'
import { CruiseSearchFilterKeys } from 'constants/cruise'
import { replace } from 'connected-react-router'
import CruiseShipsInputFilter from '../SearchPage/Filters/Inputs/CruiseShipsInputFilter'
import CruisePromotionsInputFilter from '../SearchPage/Filters/Inputs/CruisePromotionsInputFilter'

interface Props {
  filters: App.OfferListFilters
}

function CruiseFiltersDropdown({
  filters,
}: Props) {
  const dispatch = useAppDispatch()
  const { search } = useLocation()

  const onFilterChange = (nextFilters: Record<string, any>) => {
    const urlValues = Object.entries(nextFilters).map(([key, value]) => ({ paramName: key, paramValue: value }))
    let nextSearch = deleteSearchParams(search, ...CruiseSearchFilterKeys)
    nextSearch = setManySearchParamValues(nextSearch, urlValues)
    dispatch(replace({ search: nextSearch }))
  }

  return <>
    <CruiseShipsInputFilter listFilters={filters} onChange={onFilterChange} />
    <CruisePromotionsInputFilter listFilters={filters} onChange={onFilterChange} />
  </>
}

export default CruiseFiltersDropdown
